import axios from 'axios'
import Loading from 'quasar/src/plugins/Loading.js';import QSpinnerBall from 'quasar/src/components/spinner/QSpinnerBall.js';
import router from './router'
import { notifyHttpError } from './utility'

const http = axios.create({
    baseURL: '',
})

let requestCount = 0

const showLoading = () => {
    if (requestCount === 0) {
        Loading.show({
            spinner: QSpinnerBall,
            customClass: 'secondary',
            message: 'Processando...',
        })
    }
    requestCount++
}

const hideLoading = () => {
    requestCount--
    if (requestCount === 0) {
        Loading.hide()
    }
}

http.interceptors.request.use(
    c => {
        let jwt = localStorage.getItem('tk_3000')
        if (!c.url.search(window.URL_API_NODEJS) && jwt)
            c.headers.Authorization = `Bearer ${jwt}`
        if (!c.skipLoading) {
            showLoading()
        }
        return c
    },
    err => {
        if (!err.config?.skipLoading) {
            hideLoading()
        }
        return Promise.reject(err)
    },
)

http.interceptors.response.use(
    c => {
        if (!c.config.skipLoading) {
            hideLoading()
        }
        return c
    },
    err => {
        if (!err.config?.skipLoading) {
            hideLoading()
        }
        if (err.response?.status === 401) router.push('/login')
        if (err.response?.status === 403 && err.response?.data?.message === 'User inactive') {
            localStorage.removeItem('tk_3000')
            router.push('/login')
        }
        notifyHttpError(err)
        return Promise.reject(err)
    },
)

export default http
